import axios from "axios";
import OSS from "ali-oss";
import {
    Notification,
    Loading
} from "element-ui";
import store from "@/vuex";
import {
    dateToFormat
} from "@/config/_filter"

let loadingInstance; // loading组件

function getRepairFileName(file) {
    return `${Math.floor(Math.random() * 100000 + 1)}-${file.name}`;
}

const multipartUpload = function (path, files, client) {


    if (!path)
        path = 'public/' + dateToFormat();

    return new Promise(function (resolve, reject) {
        const name = getRepairFileName(files);
        client

            .multipartUpload('static/' + path + "/" + name, files.raw, {})

            .then(result => {
                resolve({
                    name: result.name,
                    url: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/" + result.name,
                    length: Math.ceil(files.size / 1024) + "KB"
                });
            })
            .catch(err => {
                Notification({
                    title: "警告",
                    message: `${files.name}上传失败,请重试`,
                    type: "warning"
                });
                reject(err);
            });
    });
};
const uploadFileSchool = async function (file, path) {
    let files = Array.isArray(file) ? file : Array.of(file);
    if (!files.length) throw new Error("请添加文件");
    let flag = false;
    let client;
    let fileList = [];
    loadingInstance = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
    });
    await axios.get('/api/get/aliyun/sts', {
        headers: {
            "Authorization": store.getters.token,
            "X-Requested-With": "XMLHttpRequest"
        }
    }).then(res => {
        client = new OSS({
            region: "oss-cn-zhangjiakou",
            accessKeyId: res.data.AccessKeyId,
            accessKeySecret: res.data.AccessKeySecret,
            stsToken: res.data.SecurityToken,
            bucket: 'steamfun',
            secure: true
        });
        flag = true;
    })
        .catch(err => {
            Notification({
                title: "警告",
                message: err,
                type: "warning"
            });
            loadingInstance.close();
            return new Promise(function (resolve, reject) {
                reject(new Error("获取token失败"));
            });
        });
    if (flag) {
        for (let i = 0; i < files.length; i++) {
            if (files[i].raw) {
                await multipartUpload(path, files[i], client)
                    .then(res => {
                        console.log(res)
                        fileList.push(res);
                    })
                    .catch(err => {
                        console.log(err)
                    });
            } else {
                fileList.push(files[i]);
            }
        }
        loadingInstance.close();
        return new Promise(function (resolve) {
            resolve(fileList);
        });
    }
};

export default uploadFileSchool;